import { tournamentsHistoryStateEndpoint as TOURNAMENTS_HISTORY_STATE_ENDPOINT } from '@/globalVariables'
import { extractMetaFromResponse } from '@/helpers'
import type { TournamentMeta } from '@/interfaces/Tournaments'
import type { TournamentsHistoryStateApiResponse } from '@/interfaces/responses/tournaments/TournamentsHistoryStateApiResponse'
import { ApiService } from '@/services/ApiService'
import { defineStore } from 'pinia'

interface TournamentsHistoryStore {
  state: TournamentsHistoryStateApiResponse | null
}

export const useTournamentsHistoryStore = defineStore('tournamentsHistoryStore', {
  state: (): TournamentsHistoryStore => ({
    state: null,
  }),
  getters: {
    meta(): TournamentMeta {
      return extractMetaFromResponse(this.state)
    },
    tournaments(): TournamentsHistoryStateApiResponse['tournaments'] | null {
      return this.state?.tournaments ?? null
    },
  },
  actions: {
    async loadState(force: boolean = false): Promise<void> {
      if (this.state && !force) return
      try {
        this.state = await ApiService.get<TournamentsHistoryStateApiResponse>(
          TOURNAMENTS_HISTORY_STATE_ENDPOINT,
          { force: true },
        )
      } catch (error: unknown) {
        console.error(error)
      }
    },
  },
})
